import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIndustryRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.2 7.6c0-1.545 1.254-2.8 2.8-2.8h2.4c1.544 0 2.8 1.255 2.8 2.8v4.245l5.19-3.03c1.6-.935 3.61.22 3.61 2.075v1.35l5.104-3.27c1.6-1.02 3.695.125 3.695 2.025V24c0 1.765-1.435 3.2-3.2 3.2H6.4A3.203 3.203 0 0 1 3.2 24zM6 7.2c-.22 0-.4.18-.4.4V24c0 .44.36.8.8.8h19.2c.44 0 .8-.36.8-.8V10.995l-6.956 4.45A1.197 1.197 0 0 1 17.6 14.43v-3.545l-6.995 4.08a1.197 1.197 0 0 1-1.8-1.035L8.8 7.6c0-.22-.18-.4-.4-.4z" })
});
export default SvgIndustryRegularIcon;
